
export interface IConfig {
    hostUrl: string;
    consentPath: string;
    apiBasePrefixV1: string;
}

const env = process.env.REACT_APP_ENV || 'DEV';
let config: IConfig;

if (env === 'DEV' || env === 'UAT') {
  config = require('./uatConfig').config;
} else {
  config = require('./prodConfig').config;
}

export default config;
